import { types } from 'mobx-state-tree';

import { BaseVehicle } from '../definitions/InsCommon';
import DailyKMValues from '../definitions/DailyKMValues';
import OwnLeaseValues from '../definitions/OwnLeaseValues';
import ParkedOvernightValues from '../definitions/ParkedOvernightValues';
import VehicleConditionValues from '../definitions/VehicleConditionValues';
import VehiclePurposeValues from '../definitions/VehiclePurposeValues';
import YearlyKMValues from '../definitions/YearlyKMValues';
import Coverage from './Coverage';


const Vehicle = BaseVehicle
    .named('Vehicle')
    .props({
        id: types.identifier,

        bodyType: types.maybeNull(types.string),

        ownLease: types.enumeration(
            Object.values(OwnLeaseValues),
        ),
        datePurchased: types.string,
        vehicleCondition: types.maybeNull(types.enumeration(
            Object.values(VehicleConditionValues)),
        ),
        winterTires: types.boolean,
        roadsideAssistance: types.maybeNull(
            types.boolean,
        ),
        parkedOvernight: types.maybeNull(types.enumeration(
            Object.values(ParkedOvernightValues),
        )),
        vehiclePurpose: types.enumeration(
            Object.values(VehiclePurposeValues),
        ),
        dailyKM: types.maybeNull(types.enumeration(DailyKMValues)),
        yearlyKM: types.maybeNull(types.enumeration(YearlyKMValues)),
        primaryDriverId: types.maybeNull(types.string),
        coverage: types.optional(Coverage, {}),
    })
    .views(self => ({
        get fullName() {
            return `${self.year} ${self.make} ${self.model}`;
        },
        get isAssignmentValid() {
            return self.primaryDriverId !== null;
        },
    }))
    .actions(self => ({
        setPrimaryDriver(driverId) {
            self.primaryDriverId = driverId;
        },
    }));

export default Vehicle;
